<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <PositionListing />
    </Layout>
</template>
<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import PositionListing from "@/views/pages/admin/position/positionListing";

export default {
    page: {
        title: i18n.t("module.position"),
    },
    components: { Layout, PageHeader, PositionListing },
    data() {
        return {
            title: i18n.t("module.position"),
            items: [
                {
                    text: i18n.t("module.recruitment"),
                    href: '/recruitments',
                },
                {
                    text: i18n.t("module.position"),
                    active: true,
                },
            ],
        };
    },
}
</script>
